"use client";
import { Disclosure } from "@headlessui/react";
import { useLazyGetFaqInfosQuery } from "@/store";
import Image from "next/image";
import { useEffect } from "react";
import { getFromLocale } from "@/utils";

const { Button, Panel } = Disclosure;

export const Faq = ({ type }) => {
  const language = getFromLocale("language");

  const [getFaqInfos, { data: faqDatas, isError }] = useLazyGetFaqInfosQuery();
  useEffect(() => {
    getFaqInfos();
  }, [language]);
  
  const filterByCategory =
    !!faqDatas && faqDatas?.body?.filter((q) => q.type === type);

  const vectorPos = (open) =>
    open ? (
      <div className="rotate-180">
        <Image
          src="/icons/vector_down.svg"
          width={16}
          height={16}
          alt="vector_down"
          aria-hidden="true"
          className="!h-6 !w-6"
        />
      </div>
    ) : (
      <Image
        src="/icons/vector_down.svg"
        width={16}
        height={16}
        alt="vector_down"
        aria-hidden="true"
        className="!h-6 !w-6"
      />
    );

  if (isError) return <h1>Something went wrong!</h1>;

  return (
    <div className="bg-white">
      <div className="sm:w-[90%] xl:w-full mx-auto max-w-[1296px] px-2">
        <div className="mx-auto w-full ">
          <dl className="space-y-6 ">
            {filterByCategory &&
              filterByCategory?.map(
                ({ title: question, description: answer }, index) => (
                  <Disclosure
                    as="div"
                    key={question}
                    className="px-5 py-4 border border-gray-900/10"
                  >
                    {({ open }) => (
                      <>
                        <dt>
                          <Button className="flex w-full items-start justify-between text-left text-mainDarkPurple">
                            <span className="sm:text-base xsm:text-lg md:text-2xl font-bold">
                            {`${ index + 1 }. ${question}`}
                            </span>
                            <span className="ml-6 flex !h-6 !w-6 items-center">
                              {vectorPos(open)}
                            </span>
                          </Button>
                        </dt>
                        <Panel as="dd" className="mt-3 lg:pr-16 pr-8">
                          <p className="sm:text-sm md:text-base leading-7 text-mainDarkPurple font-semibold px-4">
                            {answer}
                          </p>
                        </Panel>
                      </>
                    )}
                  </Disclosure>
                )
              )}
          </dl>
        </div>
      </div>
    </div>
  );
};
